import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import FieldGroup from '../../../FieldGroup.jsx';
import { validateEditorData } from '../../../editor/defaultOptions.js';
import MultistepFormsNav from '../../../headers/FormHeaders/MultistepFormsNav.jsx';
import MultistepFormsFooter from '../../../MultistepFormsFooter.jsx';

import Editor from '../../../editor/editor.jsx';

function StepDetailsForm(props) {
  const {
    handleSubmit,
    onCancel,
    onBack,
    fields,
    updateEditorInstance,
    loading,
    values,
  } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Row className="flex flex-wrap flex-align-start">
        <Col xs={12}>
          <MultistepFormsNav
            activeIndex={1}
            onBack={onBack}
            onSubmit={handleSubmit}
            type="changeStrategy"
          />
        </Col>

        {fields
          ? fields.map(({ key, label, isEditor }, index) =>
              isEditor ? (
                <Col key={key} xs={12}>
                  <Field name={key}>
                    {({ name, input, meta }) => {
                      return (
                        <Editor
                          key={`${key}-${input.value ? 'loaded' : 'empty'}`}
                          name={name}
                          data={validateEditorData(input.value)}
                          label={label}
                          setEditorInstanceForParent={(editor) =>
                            updateEditorInstance(editor, index)
                          }
                          options={{
                            holder: `${key}-change-strategy-editor`,
                            minHeight: '70',
                          }}
                          customClass="fixed-height"
                          meta={meta}
                        />
                      );
                    }}
                  </Field>
                </Col>
              ) : (
                <Col key={key} xs={12}>
                  <Field
                    name={key}
                    label={label}
                    componentClass="textarea"
                    rows={5}
                    customClass="fixed-height"
                    placeholder="Enter a Value"
                    component={FieldGroup}
                  />
                </Col>
              )
            )
          : null}
      </Row>
      <Row>
        <Col xs={12}>
          <MultistepFormsFooter
            values={values}
            loading={loading}
            handleSubmit={handleSubmit}
            onBack={onBack}
            onCancel={onCancel}
          />
        </Col>
      </Row>
    </form>
  );
}

export default StepDetailsForm;
